/**
 * Crown — full-coverage gold/PFM cap over the entire clinical crown. Uses a
 * warm metal gradient with an inner highlight to sell the polished surface.
 */
import { uid } from "./_shared";

export default function Crown({ toothId }) {
  const gid = uid("crown", toothId);
  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#FFF3C4" />
          <stop offset="40%"  stopColor="#E7B750" />
          <stop offset="100%" stopColor="#8A6420" />
        </linearGradient>
      </defs>

      {/* Cap body — follows crown contour */}
      <path
        d="M 14 40
           C 14 28 22 20 30 20
           C 38 20 46 28 46 40
           L 46 72
           Q 30 78 14 72 Z"
        fill={`url(#${gid})`}
        stroke="#5A3E10"
        strokeWidth={0.9}
      />

      {/* Occlusal ridges (cusp shading) */}
      <path d="M 21 30 Q 30 26 39 30"
            fill="none" stroke="#5A3E10" strokeOpacity={0.55} strokeWidth={0.6} />
      <ellipse cx={22} cy={34} rx={3.5} ry={4.5} fill="#FFFFFF" fillOpacity={0.4} />
      <ellipse cx={38} cy={34} rx={3.5} ry={4.5} fill="#FFFFFF" fillOpacity={0.3} />

      {/* Vertical polish streak */}
      <path d="M 24 26 Q 25 50 24 68"
            fill="none" stroke="#FFF6D8" strokeOpacity={0.55} strokeWidth={0.9} />

      {/* Gingival margin */}
      <path d="M 14 70 Q 30 78 46 70"
            fill="none" stroke="#5A3E10" strokeOpacity={0.85} strokeWidth={0.9} />
    </g>
  );
}
